export class ArticleConnectionPropertyDef {
  public static readonly TOTAL_DISTANCE: string = 'totalDistance';
  public static readonly PINS_COUNT: string = 'pinsCount';
  public static readonly MULTIPLIABLE: string = 'multipliable';
  public static readonly WIRE_BRIDGE_ARTICLE: string = 'wireBridgeArticle';
  public static readonly ADAPTER_CUSTOM_LABEL_WIDTH: string = 'adapterCustomLabelWidth';
  public static readonly TYPE: string = 'Typ';
  public static readonly COLOR: string = 'Farbe';
  public static readonly SPACING: string = 'Breite';
  public static readonly CROSS_SECTION: string = 'Querschnitt';
  public static readonly CODING_BOLT_OPENING: string = 'Kodieröffnung';
  public static readonly CODING: string = 'Kodierung';
  public static readonly CODING_REFERENCE: string = 'codingReference';
  public static readonly ARTICLE_ALTERNATIVE_GROUP: string = 'articleAlternativeGroup';
}
